class SpriteComponentData {
	constructor() {
		this.enabled = true;
	}
}

export { SpriteComponentData };
